import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants.js";

export const PartnerMenuStyled = styled.section`
    padding: 32px 16px;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 16px 8px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 8px 4px;
    }
`;

export const PartnerMenuItemStyled = styled.div`
    a {
        display: block;
        padding: 8px 16px;
        @media (max-width: ${BREAKPOINTS.small}px) {
            padding: 8px 8px;
        }
        border-radius: 4px;
        cursor: pointer;
        font-weight: 500;
        color: #a3a6cc;
        text-decoration: none;
    }

    &.active {
        a {
            background: #393c5d;
            color: #ffffff;
        }
    }

    &:hover {
        a {
            background: #393c5d;
        }
    }
`;
